import React from 'react';
import { connect } from 'react-redux';
import { loadPaymentRequest, setPaymentRequestPayment } from './actions';

let PaymentRequestButton = class PaymentRequestButton extends React.Component {
  componentDidMount() {
    this.props.loadPaymentRequest();
    if (typeof this.props.total === 'number')
      this._setupPaymentRequest(this.props.total * 100);
  }

  componentWillReceiveProps(nextProps) {
    if (
      typeof nextProps.total === 'number' &&
      nextProps.total !== this.props.total
    )
      this._setupPaymentRequest(nextProps.total * 100);
  }

  _setupPaymentRequest(cents) {
    if (!window.stripe) return;
    if (this.paymentRequest) return this._updatePaymentRequest(cents);

    const paymentRequest = window.stripe.paymentRequest({
      country: 'US',
      currency: 'usd',
      total: {
        label: 'Total',
        amount: parseInt(cents, 10)
      }
    });

    this.paymentRequest = paymentRequest;

    const elements = window.stripe.elements();
    const prButton = elements.create('paymentRequestButton', {
      paymentRequest: paymentRequest,
      style: {
        paymentRequestButton: {
          type: 'buy',
          height: '44px'
        }
      }
    });

    // Check the availability of the Payment Request API first.
    paymentRequest.canMakePayment().then(result => {
      this.props.setPaymentRequestPayment(result);
      if (result) {
        prButton.mount('#payment-request-button');
      } else {
        document.getElementById('payment-request-button').style.display =
          'none';
      }
    });

    paymentRequest.on('token', ev => {
      const onSuccess = () => ev.complete('success');
      const onFail = () => ev.complete('fail');
      return this.props.onToken(ev.token.id, onSuccess, onFail);
    });
  }

  _updatePaymentRequest(cents) {
    this.paymentRequest.update({
      total: {
        label: 'Total',
        amount: parseInt(cents, 10)
      }
    });
  }

  render() {
    return (
      <div
        style={this.props.disabled ? { display: 'none' } : {}}
        id="payment-request-button"
      />
    );
  }
};

PaymentRequestButton = connect(
  state => ({
    total: state.cart.total
  }),
  { loadPaymentRequest, setPaymentRequestPayment }
)(PaymentRequestButton);

export default PaymentRequestButton;



// WEBPACK FOOTER //
// ./shared/components/checkoutPage/paymentRequestButton.js